
import React, { Component } from 'react';
import TableRow from '@material-ui/core/TableRow';

import { Drawer } from 'ui/Drawer';
import OrderDetail from './Detail';
import styled from 'styled-components';

import TableCellStatus from './TableParts/TableCellStatus';
import TableCellDates from './TableParts/TableCellDates';
import TableCellPoints from './TableParts/TableCellPoints';
import TableCellDescription from './TableParts/TableCellDescription';
import TableCellComment from './TableParts/TableCellComment';
import TableCellOrderType from "./TableParts/TableCellOrderType";
import TableCellCargo from "./TableParts/TableCellCargo";


const StyledTableRow = styled(TableRow)`

  &:hover {
    cursor: pointer;
    background: #f8f8f8;
  }
  
  background-color: transparent;
  -webkit-transition: background-color 1s;
  transition: background-color 1s;
  
  &.updated {
    background-color: rgba(250,190,10,0.3);
  }
  
  .MuiTableCell-root {
    padding: 6px;
  }
`;



export default class OrderListItem extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isDrawerOpen: false,
      updated: this.props.item.updated
    };

    this.ref = React.createRef();
  }

  isPreviewOpen = () => {
    const { item, previewId } = this.props;
    return previewId !== undefined && String(previewId) === String(item.id);
  };

  openPreview = () => {
    const { item, onPreview, listPath } = this.props;
    if (onPreview) {
      onPreview(item);
      return;
    }
    this.setState({ isDrawerOpen: true });
  };

  closePreview = () => {
    const { onClosePreview } = this.props;
    if (onClosePreview) {
      onClosePreview();
      return;
    }
    this.setState({ isDrawerOpen: false });
  };

  isChanged = (updated) => {
    if (this.state.updated !== updated) {
      this.setState({
        updated: updated
      });
      return true;
    }
    return false;
  };

  componentDidUpdate(prevProps, prevState) {
    const { item } = this.props;
    if (this.state.updated !== item.updated) {
      this.setState({
        updated: item.updated
      });
      this.ref.current.classList.add('updated');
      setTimeout(() => this.ref.current.classList.remove('updated'), 500);
    }
  }

  render() {
    const { item, apiUrl = 'order', basePath = '/order', listPath, onPreview } = this.props;
    const isDrawerOpen = this.isPreviewOpen() || this.state.isDrawerOpen;
    const fromPath = listPath ? `${listPath}/preview/${item.id}` : undefined;

    let color = '#fff';
    if (isDrawerOpen) {
      color = '#f5005714';
    }
    else if (item.order_status && item.order_status.color) {
      color = item.order_status.color + '33'
    }

    return (
      <React.Fragment>
        <StyledTableRow
          onClick={() => this.openPreview()}
          ref={this.ref}
          style={{backgroundColor: color}}
        >
          <TableCellStatus item={item} />
          <TableCellDates item={item} />
          <TableCellOrderType item={item} />
          <TableCellPoints item={item} />
          <TableCellCargo item={item} />
          <TableCellDescription item={item} />
          <TableCellComment item={item} />
        </StyledTableRow>
        {!onPreview && (
          <Drawer
            open={isDrawerOpen}
            onClose={() => this.closePreview()}
            width={'450px'}
            disableEscapeKeyDown={true}
          >
            <OrderDetail
              id={item.id}
              onClose={this.closePreview}
              apiUrl={apiUrl}
              basePath={basePath}
              fromPath={fromPath}
            />
          </Drawer>
        )}
      </React.Fragment>
    )
  }
};

